import { Item } from '@/schemaTypes'

export function findRelatedEmailForItemEvent(item: Item) {
  if (item && item.events) {
    for (let i = item.events.length - 1; i >= 0; i--) {
      if (item.events[i] && item.events[i].meta) {
        return item.events[i]?.meta?.emailAddress
      }
    }
  }
  return ''
}
